const selectorDataBitel = (state) => {
  return state.dataBitel;
};

const selectorDataUnitel = (state) => {
  return state.dataUnitel;
};

const selectorDataHalotel = (state) => {
  return state.dataHalotel;
};
const selectorDataSabayGame = (state) => {
  return state.dataSabayGame;
};
const selectorDataAirtimeHalotel = (state) => {
  return state.dataBitel;
};

const selectorDataMytel = (state) => {
  return state.dataMytel;
};
const selectorDataMagicWeel = (state) => {
  return state.dataMagicWheel;
};
const selectorDataMathMatch = (state) => {
  return state.dataMathMatch;
};
const selectorDataMovitel = (state) => {
  return state.dataMovitel;
}
const selectorDataMytelErrorCode = (state) => {
  return state.dataMytelErrorCode;
};

const selectorDataProject = (state) => {
  return state.dataInfoRevenue.dataInfoRevenvue;
};

const selectorDataMytelVm = (state) => {
  return state.dataMytelVm;
};

const selectorDataBicagame = (state) => {
  return state.dataBicagame;
};


export {
  selectorDataBitel,
  selectorDataHalotel,
  selectorDataAirtimeHalotel,
  selectorDataMytel,
  selectorDataProject,
  selectorDataUnitel,
  selectorDataMytelErrorCode,
  selectorDataMytelVm,
  selectorDataMagicWeel,
  selectorDataBicagame,
  selectorDataMovitel,
  selectorDataMathMatch,
  selectorDataSabayGame
};
